import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from '../styles/contact.module.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from "../components/home/Footer";
const Contact = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
    });
    const [submitMessage, setSubmitMessage] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePhoneChange = (value) => {
        setFormData(prev => ({
            ...prev,
            phone: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setSubmitMessage(null);
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

            const urlencoded = new URLSearchParams();
            urlencoded.append("user_id", formData.email);
            urlencoded.append("first_name", formData.firstName);
            urlencoded.append("last_name", formData.lastName);
            urlencoded.append("phone", formData.phone);
            urlencoded.append("text_message", formData.message);

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: urlencoded,
                redirect: "follow"
            };

            const response = await fetch("https://8xkv4pugp8.execute-api.ap-south-1.amazonaws.com/default/record_leads", requestOptions);

            const result = await response.json(); // Parse the JSON body

            if (response.ok) {
                const successMessage = result.message || "Thank you! Your message has been sent.";
                toast.success(successMessage);
                // console.log("Response:", result);

                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    message: ''
                });
            } else {
                const errorMessage = result.error || "Sorry, there was a problem sending your message. Please try again later.";
                toast.error(errorMessage);
                console.error("Error response:", result);
            }
        } catch (error) {
            toast.error("Sorry, there was a problem sending your message. Please try again later.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="contact-page min-h-screen pt-20">


            <div className={styles['contact-form-container']}>
                <h1>Get in touch</h1>
                <p>We'd love to hear from you. Please fill out this form.</p>
                <form onSubmit={handleSubmit}>
                    <div className={styles['form-row']}>
                        <div className={styles['form-group']}>
                            <label htmlFor="firstName">First name</label>
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                placeholder="First name"
                                value={formData.firstName}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className={styles['form-group']}>
                            <label htmlFor="lastName">Last name</label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                placeholder="Last name"
                                value={formData.lastName}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </div>

                    <div className={styles['form-group']}>
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="you@company.com"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className={styles['form-group']}>
                        <label htmlFor="phone">Phone number</label>
                        <PhoneInput
                            country={'in'}
                            value={formData.phone}
                            onChange={handlePhoneChange}
                            inputProps={{
                                id: 'phone',
                                required: true,
                            }}
                            containerClass={styles['phone-input-container']}
                            inputClass={styles['phone-input-field']}
                            buttonClass={styles['phone-input-dropdown']}
                            dropdownClass={styles['phone-input-country-dropdown']}
                        />
                    </div>

                    <div className={styles['form-group']}>
                        <label htmlFor="message">Message</label>
                        <textarea
                            id="message"
                            name="message"
                            rows="4"
                            placeholder="Your message"
                            value={formData.message}
                            onChange={handleInputChange}
                            required
                        ></textarea>
                    </div>

                    <button type="submit" className={styles['submit-btn']} disabled={submitting}>
                        {submitting ? 'Sending...' : 'Send message'}
                    </button>
                </form>
                <ToastContainer position="top-center" autoClose={4000} hideProgressBar={false} newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover />

            </div>

            <footer className="footer" id="contact">
                <div className="footer-content">
                    <div className="footer-brand">
                        <span><span style={{ color: '#FF5B15', fontWeight: '600', fontSize: '24px' }}>Route</span><span style={{ color: '#0A0A0A', fontWeight: '400', fontSize: '24px' }}>chef</span></span>
                        <p>Your AI Powered Route Planner for Confirmed Journeys.</p>
                    </div>
                    <div className="footer-links">
                        <h4>Links</h4>
                        <ul>
                            <li><button onClick={() => navigate("/")}>Home</button></li>
                        </ul>
                    </div>
                    <div className="footer-download">
                        <h4>Scan to Download App</h4>
                        <div className="qr-code">
                            <img src="/qrcode.png" alt="Download QR Code" />
                        </div>
                        <p>Contact: <a href="mailto:info@routechef.com">info@routechef.com</a></p>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="social-icons">
                        <a href="https://www.facebook.com/routechef/" className="social-icon" target="_blank" rel="noopener noreferrer">f</a>
                        <a href="https://www.linkedin.com/company/105943037" className="social-icon" target="_blank" rel="noopener noreferrer">in</a>
                        <a href="#" className="social-icon">yt</a>
                        <a href="https://www.instagram.com/routechef/" className="social-icon" target="_blank" rel="noopener noreferrer">ig</a>
                    </div>
                    <p className="copyright">© 2025 Routechef</p>
                    <div className="footer-extra">
                        <span>Made with ❤️ in India</span>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Contact;